import React from 'react';
import { useBackground, BackgroundType } from '../../contexts/BackgroundContext';

const GlobalBackground: React.FC = () => {
  const { settings, getCurrentOverlay } = useBackground();

  const backgroundVideos: Record<BackgroundType, string | null> = {
    purple: '/videos/dark-purple-and-blue-rich-colored-text-friendly-looping-animated-background-SBV-347377619-HD.mp4',
    hexagon: '/videos/technology-hexagon-pattern-business-corporate-particles-tunnel-digital-background-l-SBV-352259109-HD.mp4',
    cyber: '/videos/cyber-security-concept-digital-binary-code-background-SBV-347508729-HD.mp4',
    flowing: '/videos/futuristic-flowing-lines-and-glowing-particles-in-digital-cyberspace-background-SBV-348993968-HD.mp4',
    hitech: '/videos/futuristic-hi-tech-fly-hud-background-SBV-338642870-HD.mp4',
    honeycomb: '/videos/hexagonal-honeycomb-texture-movement-uhd-4k-background-backdrop-texture-SBV-334514181-HD.mp4',
    off: null,
  };

  const overlayClasses = {
    // Dark mode overlays
    default: 'bg-overlay-default',
    dark: 'bg-overlay-dark',
    blue: 'bg-overlay-blue',
    minimal: 'bg-overlay-minimal',
    // Light mode overlays
    'light-default': 'bg-overlay-light-default',
    'light-bright': 'bg-overlay-light-bright',
    'light-warm': 'bg-overlay-light-warm',
    'light-minimal': 'bg-overlay-light-minimal',
    // Common
    none: 'bg-transparent',
  };

  const currentVideo = backgroundVideos[settings.backgroundType];
  const currentOverlay = getCurrentOverlay();


  if (settings.backgroundType === 'off') {
    return (
      <div className="fixed inset-0 pointer-events-none -z-50">
        {/* Show original dark background when off */}
        <div className="absolute inset-0 w-full h-full bg-theme-bg dark:bg-dark-theme-bg" />
      </div>
    );
  }

  return (
    <div className="fixed inset-0 pointer-events-none -z-50">
      {/* Animated gradient fallback */}
      <div 
        className="absolute inset-0 w-full h-full bg-gradient-animated"
      />
      
      {/* Video Background */}
      {currentVideo && (
        <video 
          key={settings.backgroundType}
          autoPlay 
          muted 
          loop 
          playsInline
          className="absolute inset-0 w-full h-full object-cover opacity-80"
          onError={(e) => console.error('Video failed to load:', e)}
          onLoadStart={() => {}}
          onLoadedData={() => {}}
          onLoadedMetadata={(e) => {
            const video = e.target as HTMLVideoElement;
            video.playbackRate = settings.playbackSpeed;
          }}
          ref={(video) => {
            if (video) {
              video.playbackRate = settings.playbackSpeed;
            }
          }}
        >
          <source src={currentVideo} type="video/mp4" />
        </video>
      )}
      
      {/* Edge Feather Effect */}
      {settings.edgeFeather && (
        <div className="absolute inset-0 bg-edge-feather" />
      )}
      
      {/* Color Overlay */}
      <div 
        className={`absolute inset-0 ${overlayClasses[currentOverlay]}`}
      />
    </div>
  );
};

export default GlobalBackground;